import useNetworkRequest from "./useNetworkRequest";

const useEdd = () =>
  useNetworkRequest({
    networkCallParams: {
      url: "v2/limits/edd/progress",
      method: "GET",
      service: "wallet",
    },
  });

export default useEdd;
